import React, { useEffect, useMemo, useState } from "react";
import "../scss/button.scss";
import "../scss/WelcomeBack.scss";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import GooglePlay from "../images/google-play.png";
import AppStore from "../images/app-store.png";
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageHeader from "../components/PageHeader";
import { useDispatch, useSelector, } from 'react-redux';
import { setLoanSummary, setPageError, setPartnerLocDetails } from '../lib/features/eligibilitySlice';
import CenteredPopup from '../components/popups/CenteredPopup';
import { formatDate, formatMoney } from "../lib/util/utilities";
import { useDisburseNextEmiMutation } from "../lib/services/eligibilityApi";
import { useTapClickMutation } from "../lib/middleware/TapClickApi";
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

function EnachCongratulations() {
  const { pageerror, loanSummaryData = {} } = useSelector((state) => state.eligibility);
  //const [loanSummary] = useLoanSummaryMutation();
  const [DisburseNextEmi] = useDisburseNextEmiMutation()
  const [tapClick] = useTapClickMutation();
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
  const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
  const device_id = useMemo(() => queryParams.get('device_id'), [queryParams])
  const secret = useMemo(() => queryParams.get('secret'), [queryParams])
  const utmSource = useMemo(() => queryParams.get('utm_source'), [queryParams])

  const handleOpen = () => {
    setIsModalOpen(true);
  }

  const handleClose = () => {
    setIsModalOpen(false);
    dispatch(setPageError(''))
  }

  const modalButtons = [
    { label: 'Close', onClick: handleClose }
  ]

  const Loansummary = async () => {
    try {
      const requestData = {}
      let jwt_token
      if (jwt) {
        jwt_token = jwt
        localStorage.setItem('jwt', jwt)
      } else {
        jwt_token = localStorage.getItem('jwt')
      }
      const scrt = secret ? secret : localStorage.getItem('secret')
      //const result = await loanSummary({ ...requestData, jwt_token, scrt, device_id })
      const result = await DisburseNextEmi({ ...requestData, jwt_token, scrt, utmSource })
      if (result.data && result.data.status === 'error') {
        dispatch(setPageError(result.data.message))
        if (result.data.message === 'Login expired! Please re-login.') {
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone')
          localStorage.clear()
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
          
        }
        handleOpen()
      } else if (result.data && result.data.message === 'Login expired! Please re-login.') {
        dispatch(setPageError(result.data.message))
        localStorage.removeItem('jwt');
        localStorage.removeItem('lastVisitedPage');
        const phone = localStorage.getItem('phone')
        localStorage.clear()
        phone ? navigate(`/?phone=${phone}`) : navigate('/');
        
      } else if (result.error) {
        dispatch(setPageError('Please check your internet or try again later.'))
        handleOpen()
      } else {
        dispatch(setLoanSummary(result.data?.data));
      }
    } catch (error) {
      dispatch(setPageError('Something went wrong. Please try again later.'));
      handleOpen()
    }
  }

  useEffect(()=> {
    Loansummary()
  },[])

  useEffect(() => {
    if(loanSummaryData) {
      pushCleverTapEvent({
        event_name: 'web_post_disbursal_screen',
        event_property: {
          Source: window.localStorage.getItem('utm_source'),
          segment: localStorage.getItem('customerSegment') === "A3-A6" ? "Non-STP" : "STP",
          "Loan amount": loanSummaryData?.approved_amount,
          "EMI Start Date": loanSummaryData?.next_emi_date,
        }
      });
    }
  }, [loanSummaryData, tapClick]);
  
  return (
    <div className="external-wrapper">
      <CenteredPopup
        isOpen={isModalOpen}
        buttons={modalButtons}
        onClose={handleClose} icon={<WarningIcon />}>
        <p>{pageerror}</p>
      </CenteredPopup>
      <div className="page-content enach-success-page">
        <PageHeader />
        <div className="approval-content">
          <div className="welcome-back">
            <h1 className="title">Welcome back!</h1>
            {loanSummaryData && <p className="subtitle">
              Your <strong>{`₹ ${formatMoney(loanSummaryData?.approved_amount)}`}</strong> loan has been disbursed on <strong>{formatDate(loanSummaryData?.loan_disbursal_date, "-")}</strong>. You can check
              your all loan details by downloading the Stashfin app.
            </p>}
            <div className="loan-emi-details">
              <div className="loan-emi-details-partition">
                <div className="loan-emi-details-part">
                  <p className="loan-emi-details-label">Personal Loan</p>
                  <p className="loan-emi-details-status"> <p className="greenDot"/> Active</p>
                </div>
                <div className="loan-emi-details-part">
                  <p className="loan-emi-details-label">EMI Starts from</p>
                  <p className="loan-emi-details-status">-</p>
                </div>
              </div>
              {loanSummaryData && <div className="loan-emi-details-highlight">
                <p className="loan-emi-details-amount">{`₹ ${formatMoney(loanSummaryData?.approved_amount)}`}</p>
                <p className="loan-emi-details-separater">|</p>
                <p className="loan-emi-details-amount">{formatDate(loanSummaryData?.next_emi_date, "/")}</p>
              </div>}
            </div>
          </div>
          <div className="unlock-info-welcome-back">
            <p className="title">
              Download the app and get your <br/> all loan details.
            </p>
            <div className="logo-links">
              <StarfinLogo className="logo" />
              <div className="download-links">
                <Link to="https://stash.page.link/68s3" target="_blank">
                  <img src={AppStore} alt="App Store" />
                </Link>
                <Link to="https://stash.page.link/68s3" target="_blank">
                  <img src={GooglePlay} alt="Play Store" />
                </Link>
              </div>
            </div>
          </div>
          <div className="bottom-footer welcome-back-footer">
            <button
              className="btn btn-primary"
              onClick={() => {
                window.open("https://stash.page.link/68s3", "_blank");
              }}
            >
              Download Stashfin App Now!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnachCongratulations;
